import { AppState } from '../root.reducer';

export const getIntegratorIds = (state: AppState) => state.integrator.results;
export const getIntegrators = (state: AppState) => state.integrator.results.map((i) => state.entities.integrator[i]);
export const getIntegratorCsvURL = (state: AppState) => state.integrator.csvURL;
